import Vue from 'vue'
import Router from 'vue-router'
const innerLayout = () =>
    import("@/views/layout/inner_layout");
//横向nav时，打开下句
const Layout = () =>
    import("@/views/layout/layout_horizontal");

Vue.use(Router)

export const constantRouterMap = [{
    path: '/login',
    component: () =>
        import("@/views/login/login"),
    hidden: true
},
{
    path: '/sso/logout',
    hidden: true,
    component: () =>
        import("@/views/login/logout")
},
{
    path: '/404',
    component: () =>
        import('@/views/errorPage/404'),
    hidden: true
},
{
    path: '/',
    component: Layout,
    redirect: '/bigData',
    hidden: true
},
{
    path: '/bigData',
    component: Layout,
    redirect: '/bigData/home',
    meta: {
        title: '',
        icon: "el-icon-star-off"
    },
    children: [
        {
            path: 'home',
            component: () =>
                import("@/views/bigData/home"),
            name: 'home',
            meta: {
                title: '首页',
                icon: ''
            }
        },
        {
            path: 'xczxcp',
            component: () =>
                import("@/views/bigData/xczxcp"),
            name: 'xczxcp',
            meta: {
                title: '数字农业农村',
                icon: ''
            }
        },
        {
            path: 'szhyy',
            component: () =>
                import("@/views/bigData/szhyy"),
            name: 'szhyy',
            meta: {
                title: '数字化运营',
                icon: ''
            }
        },
        {
            path: 'sncjjr',
            component: () =>
                import("@/views/bigData/sncjjr"),
            name: 'sncjjr',
            meta: {
                title: '三农场景金融',
                icon: ''
            }
        },
        {
            path: 'stjs',
            component: () =>
                import("@/views/bigData/stjs"),
            name: 'stjs',
            meta: {
                title: '生态建设',
                icon: ''
            }
        },
        {
            path: 'gyan',
            component: () =>
                import("@/views/bigData/gyan"),
            name: 'gyan',
            meta: {
                title: '关于安农',
                icon: ''
            }
        },
        {
            path: 'xjgl',
            component: () =>
                import("@/views/bigData/xjgl"),
            name: 'xjgl',
            meta: {
                title: '现金管理平台',
                icon: ''
            }
        },
        {
            path: 'sjfn',
            component: () =>
                import("@/views/bigData/sjfn"),
            name: 'sjfn',
            meta: {
                title: '数据赋能',
                icon: ''
            }
        },
        {
            path: 'kjfn',
            component: () =>
                import("@/views/bigData/kjfn"),
            name: 'kjfn',
            meta: {
                title: '科技赋能',
                icon: ''
            }
        },
        {
            path: 'nbzl',
            component: () =>
                import("@/views/bigData/nbzl"),
            name: 'nbzl',
            meta: {
                title: '农业保险管理平台',
                icon: ''
            }
        },
        
        {
            path: 'sncjjrzx',
            component: () =>
                import("@/views/bigData/sncjjrzx"),
            name: 'sncjjrzx',
            meta: {
                title: '三农场景金融咨询',
                icon: ''
            }
        },
        {
            path: 'zfyw',
            component: () =>
                import("@/views/bigData/zfyw"),
            name: 'zfyw',
            meta: {
                title: '支付管理平台',
                icon: ''
            }
        },
        {
            path: 'sznynccpyx',
            component: () =>
                import("@/views/bigData/sznynccpyx"),
            name: 'sznynccpyx',
            meta: {
                title: '数字农业农村产品体系',
                icon: ''
            }
        },
        {
            path: 'zcsx',
            component: () =>
                import("@/views/bigData/zcsx"),
            name: 'zcsx',
            meta: {
                title: '整村授信平台',
                icon: ''
            }
        },
        {
            path: 'jxf',
            component: () =>
                import("@/views/bigData/jxf"),
            name: 'jxf',
            meta: {
                title: '金小蜂平台',
                icon: ''
            }
        },{
            path: 'xwzx',
            component: () =>
                import("@/views/bigData/xwzx"),
            name: 'xwzx',
            meta: {
                title: '新闻中心',
                icon: ''
            }
        },{
            path: 'xwzxDetail',
            component: () =>
                import("@/views/bigData/xwzxDetail"),
            name: 'xwzxDetail',
            meta: {
                title: '新闻中心详情',
                icon: ''
            }
        },
    ]
},

{
    path: '*',
    redirect: '/404',
    hidden: true
}
]
export default new Router({
    mode: "history",//浏览模式切换
    scrollBehavior: () => {
        document.getElementsByClassName("el-scrollbar__wrap")[0] ? document.getElementsByClassName("el-scrollbar__wrap")[0].scrollTop = 0 : '';
        return {
            y: 0
        }
    },
    routes: constantRouterMap
})

//解决路由重复点击报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
